import { FC, useContext } from 'react'
import { Button, Icon } from '@components/Generic'
import { observer } from 'mobx-react'
import { StoreContext } from '@store/Root.store'
import type { CSSProperties } from 'react'
import './Addons.css'

interface ScrollDocumentButtonProps {
  onClick?: () => void
  bottomOffset?: number
  showScrollToBottomButton?: boolean
}

export const ScrollDocumentButton: FC<ScrollDocumentButtonProps> = observer(
  ({ onClick, bottomOffset = 0, showScrollToBottomButton = false }) => {
    const store = useContext(StoreContext)
    const { signDocumentPage: trans } = store.TranslationsState.translations

    const scrollToBottom = () => {
      const element = document.querySelector('.pdf-viewer-virtualized-list')

      if (element) {
        element.scrollTop = element.scrollHeight

        onClick && onClick()
      }
    }

    return (
      <div
        className="pdf-addons__scroll-document-button-container"
        style={
          {
            '--sdb-bottom': `calc(10px + ${bottomOffset}px)`,
            '--sdb-bottom-mobile': `calc(-15px + ${bottomOffset}px)`,
            '--sdb-visibility': showScrollToBottomButton ? 'visible' : 'hidden',
          } as CSSProperties
        }
      >
        <Button onClick={scrollToBottom} tabIndex={0} dataTestid="test-scroll-bottom">
          <span className="generic__button-text generic__button-text-nowrap">
            {trans.scrollButton}
          </span>
          <Icon color="currentColor" colorHover="currentColor" type="arrow-down" size="20px" />
        </Button>
      </div>
    )
  }
)
